//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
// Using `import uuid from 'uuid/v4';` will sometimes cause an error when
// @nuskin/design-components is being imported into another package.
import { v4 as uuid } from 'uuid';
import { NsIcon } from '@nuskin/ns-icon';

export default {
  components: {
    NsIcon,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: () => uuid(),
    },
    icon: {
      type: String,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      inputValue: this.value,
    };
  },
  computed: {
    containerClass: (vm) =>
      vm.disabled ? 'text-field__container--disabled' : '',
    inputListeners: (vm) => {
      return Object.assign({}, vm.$listeners, {
        input(evt) {
          vm.inputValue = evt.target.value;
        },
      });
    },
  },
  watch: {
    inputValue(val) {
      /**
       * The input event, handled for v-model support.
       *
       * @event input
       * @type {string}
       */
      this.$emit('input', val);
    },
    value(val) {
      this.inputValue = val;
    },
  },
  methods: {
    clearInput() {
      this.inputValue = '';
      this.$refs.input.focus();
      this.$emit('clear');
    },
  },
};
